import { breaking, hotList } from '@/mocks/news';

export default function Hero() {
  return (
    <section id="breaking" className="relative scroll-mt-16">
      <div className="relative h-[520px] w-full overflow-hidden md:h-[600px]">
        <img
          src={breaking.image}
          alt="吃瓜新闻深度报道 事件还原封面图"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/70" />
      </div>

      <div className="mx-auto -mt-[460px] max-w-7xl px-4 pb-10 md:-mt-[520px] md:px-6">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          {/* 主头条 */}
          <div className="flex flex-col justify-end lg:col-span-2 lg:min-h-[360px]">
            <span className="inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-foreground-950">
              <i className="ri-fire-fill text-sm" aria-hidden="true" /> {breaking.tag}
            </span>
            <p className="mt-4 text-xs font-medium tracking-widest text-background-100/90 md:text-sm">
              {breaking.kicker}
            </p>
            <h1 className="mt-3 max-w-3xl font-heading text-2xl font-black leading-snug text-background-50 md:text-4xl">
              {breaking.title}
            </h1>
            <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
              {breaking.summary}
            </p>
            <div className="mt-6 flex flex-col items-start gap-3 sm:flex-row sm:items-center">
              <a
                href="#deep"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-background-100"
              >
                阅读报道 <i className="ri-arrow-right-line" aria-hidden="true" />
              </a>
              <span className="flex items-center gap-2 text-xs text-background-100/80">
                <i className="ri-user-3-line" aria-hidden="true" /> {breaking.author}
                <i className="ri-time-line ml-2" aria-hidden="true" /> {breaking.time}
              </span>
            </div>
          </div>

          {/* 侧栏快览 */}
          <aside
            className="hidden rounded-lg border border-background-100/20 bg-foreground-950/55 p-5 backdrop-blur-sm lg:block"
            aria-label="最新热点快览"
          >
            <div className="flex items-center justify-between border-b border-background-100/20 pb-3">
              <h2 className="flex items-center gap-2 text-sm font-bold text-background-50">
                <i className="ri-flashlight-fill text-accent-500" aria-hidden="true" /> 正在升温
              </h2>
              <a href="#topics" className="text-xs text-background-100/70 hover:text-accent-400">
                更多
              </a>
            </div>
            <ul className="mt-3 space-y-1">
              {hotList.slice(0, 5).map((h) => (
                <li key={h.rank}>
                  <a
                    href="#feed"
                    className="group flex items-start gap-3 rounded-md px-2 py-2 transition-colors hover:bg-background-100/10"
                  >
                    <span className="font-heading text-base font-bold text-accent-500">
                      {String(h.rank).padStart(2, '0')}
                    </span>
                    <span className="line-clamp-2 text-sm leading-snug text-background-100 group-hover:text-background-50">
                      {h.title}
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </aside>
        </div>
      </div>
    </section>
  );
}